module.exports = __webpack_public_path__ + "static/img/Serve08@2x.45df09c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Serve08@2x.png
// module id = FWFq
// module chunks = 1